import React, { useState } from "react";

import ReactApexChart from "react-apexcharts";

const CircleChart = () => {
  const [state] = React.useState({
    series: [44, 55, 67],
    options: {
      chart: {
        height: 350,
        widrh: 350,
        type: "radialBar",
      },
      plotOptions: {
        radialBar: {
          dataLabels: {
            name: {
              fontSize: "22px",
            },
            value: {
              fontSize: "16px",
            },
            total: {
              show: true,
              label: "",
              fontSize: "35px",
              formatter: function () {
                return 249;
              },
            },
          },
          barLabels: {
            enabled: true,
            useSeriesColors: true,
            offsetX: 210,
            fontSize: "16px",
            formatter: function (seriesName, opts) {
              return (
                seriesName + ":  " + opts.w.globals.series[opts.seriesIndex]
              );
            },
          },
        },
      },
      colors: ["#009C97", "#19BFB7", "#6960EC"],
      labels: ["Linkedin", "Job Boards", "Referrals"],
    },
  });

  return (
    <div className="w-full">
      {/* <h2 className="text-lg font-semibold mb-3">Radial Chart</h2> */}
      <ReactApexChart
        options={state.options}
        series={state.series}
        type="radialBar"
        height={350}
      />
    </div>
  );
};

const CircleCharCompany = () => {
  const [state] = React.useState({
    series: [44, 55, 67],
    options: {
      chart: {
        offsetX: -50,
        height: 250,
        width: 420,
        type: "radialBar",
      },
      plotOptions: {
        radialBar: {
          dataLabels: {
            name: {
              fontSize: "22px",
            },
            value: {
              fontSize: "22px",
            },
            total: {
              show: true,
              label: "",
              fontSize: "35px",
              formatter: function () {
                return 249;
              },
            },
          },
          barLabels: {
            enabled: true,
            useSeriesColors: true,
            offsetX: 210,
            offsetY: 100,
            fontSize: "16px",
            formatter: function (seriesName, opts) {
              return seriesName;
            },
          },
        },
      },
      colors: ["#009C97", "#19BFB7", "#6960EC"],
      labels: ["Job boards", "Linkedin", "Referrals"],
    },
  });

  return (
    <div className="w-full h-full flex items-center justify-center">
      {/* <h2 className="text-lg font-semibold mb-3">Radial Chart</h2> */}
      <ReactApexChart
        options={state.options}
        series={state.series}
        type="radialBar"
        height={250}
        width={420}
      />
    </div>
  );
};
const CircleChartManager = () => {
  const [state] = React.useState({
    series: [44, 55, 67],
    options: {
      chart: {
        offsetX: -30,
        height: 250,
        width: 580,
        type: "radialBar",
      },
      plotOptions: {
        radialBar: {
          dataLabels: {
            name: {
              fontSize: "22px",
            },
            value: {
              fontSize: "22px",
            },
            total: {
              show: true,
              label: "",
              fontSize: "35px",
              formatter: function () {
                return 249;
              },
            },
          },
          barLabels: {
            enabled: true,
            useSeriesColors: true,
            offsetX: 290,
            offsetY: 130,
            fontSize: "16px",
            formatter: function (seriesName, opts) {
              return seriesName;
            },
          },
        },
      },

      colors: ["#6077EC", "#FA5B3C", "#FF9658"],
      labels: ["Job boards ●", "Linkedin ●", "Referrals ●"],
    },
  });

  return (
    <div className="w-full h-full flex items-center justify-center">
      {/* <h2 className="text-lg font-semibold mb-3">Radial Chart</h2> */}
      <ReactApexChart
        options={state.options}
        series={state.series}
        type="radialBar"
        height={420}
        width={580}
      />
    </div>
  );
};

const LineDashedChart = () => {
  const [state, setState] = React.useState({
    series: [
      {
        data: [45, 52, 38, 24, 33, 26, 21, 20, 6, 8, 15, 10],
      },
      {
        data: [35, 41, 62, 42, 13, 18, 29, 37, 36, 51, 32, 35],
      },
    ],
    options: {
      chart: {
        height: 350,
        width: 350,
        type: "line",
        zoom: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        width: [5, 3],
        curve: "straight",
        dashArray: [0, 6],
      },
      yaxis: {
        title: {
          text: "Average Days to Hire",
          align: "left",
        },
      },
      legend: {
        tooltipHoverFormatter: function (val, opts) {
          return (
            val +
            " - <strong>" +
            opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
            "</strong>"
          );
        },
      },
      markers: {
        size: 0,
        hover: {
          sizeOffset: 10,
        },
      },

      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
      tooltip: {
        enabled: true,
        y: [
          {
            title: {
              formatter: function (val) {
                return val + " (mins)";
              },
            },
          },
          {
            title: {
              formatter: function (val) {
                return val + " per session";
              },
            },
          },
          {
            title: {
              formatter: function (val) {
                return val;
              },
            },
          },
        ],
      },
      grid: {
        borderColor: "#f1f1f1",
      },
      colors: ["#6960EC", "#B692F6"],
    },
  });

  return (
    <div className="w-full">
      <ReactApexChart
        options={state.options}
        series={state.series}
        type="line"
        height={350}
        width="100%"
      />
    </div>
  );
};

const LineDashedChartCompanyAverage = () => {
  const [state, setState] = React.useState({
    series: [
      {
        data: [45, 52, 38, 24, 33, 26, 21, 20, 6, 8, 15, 10],
      },
      // {
      //   data: [35, 41, 62, 42, 13, 18, 29, 37, 36, 51, 32, 35],
      // },
    ],
    options: {
      chart: {
        height: 350,
        width: 350,
        type: "line",
        zoom: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        width: [5, 3],
        curve: "straight",
        dashArray: [0, 0],
      },
      yaxis: {
        title: {
          text: "No of hires",
          align: "left",
          style: {
            fontSize: "14px",
            fontWeight: 600,
          },
        },
      },

      legend: {
        tooltipHoverFormatter: function (val, opts) {
          return (
            val +
            " - <strong>" +
            opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
            "</strong>"
          );
        },
      },
      markers: {
        size: 0,
        hover: {
          sizeOffset: 10,
        },
      },

      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
      tooltip: {
        enabled: true,
        y: [
          {
            title: {
              formatter: function (val) {
                return val + " (mins)";
              },
            },
          },
          {
            title: {
              formatter: function (val) {
                return val + " per session";
              },
            },
          },
          {
            title: {
              formatter: function (val) {
                return val;
              },
            },
          },
        ],
      },
      grid: {
        borderColor: "#f1f1f1",
      },
      colors: ["#6960EC"],
    },
  });

  return (
    <div className="w-full">
      <ReactApexChart
        options={state.options}
        series={state.series}
        type="line"
        height={350}
        width="100%"
      />
    </div>
  );
};

const LineDashedChartManager = () => {
  const [state, setState] = React.useState({
    series: [
      {
        data: [45, 52, 38, 24, 33, 26, 21, 20, 6, 8, 15, 10],
      },
    ],
    options: {
      chart: {
        height: 350,
        width: 350,
        type: "line",
        zoom: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        width: [5],
        curve: "straight",
        dashArray: [0],
      },
      yaxis: {
        title: {
          text: "Average Days to Hire",
          align: "left",
        },
      },
      legend: {
        tooltipHoverFormatter: function (val, opts) {
          return (
            val +
            " - <strong>" +
            opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
            "</strong>"
          );
        },
      },
      markers: {
        size: 0,
        hover: {
          sizeOffset: 10,
        },
      },

      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        title: {
          text: "Months",
        },
      },
      tooltip: {
        enabled: true,
        y: [
          {
            title: {
              formatter: function (val) {
                return val + " (mins)";
              },
            },
          },
          {
            title: {
              formatter: function (val) {
                return val + " per session";
              },
            },
          },
          {
            title: {
              formatter: function (val) {
                return val;
              },
            },
          },
        ],
      },
      grid: {
        borderColor: "#f1f1f1",
      },
      colors: ["#FFBF00"],
    },
  });

  return (
    <div className="w-full">
      <ReactApexChart
        options={state.options}
        series={state.series}
        type="line"
        height={350}
        width="100%"
      />
    </div>
  );
};

const LineDashedChartCompanySuccess = () => {
  const [state, setState] = React.useState({
    series: [
      {
        data: [35, 41, 62, 42, 13, 18, 29, 37, 36, 51, 32, 35],
      },
      // {
      //   data: [45, 52, 38, 24, 33, 26, 21, 20, 6, 8, 15, 10],
      // },
    ],
    options: {
      chart: {
        height: 350,
        width: 350,
        type: "line",
        zoom: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        width: [5, 3],
        curve: "straight",
        dashArray: [0, 0],
      },
      yaxis: {
        title: {
          text: "No of Candidates",
          align: "left",
          style: {
            fontSize: "14px",
            fontWeight: 600,
          },
        },
      },

      legend: {
        tooltipHoverFormatter: function (val, opts) {
          return (
            val +
            " - <strong>" +
            opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
            "</strong>"
          );
        },
      },
      markers: {
        size: 0,
        hover: {
          sizeOffset: 10,
        },
      },

      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
      tooltip: {
        enabled: true,
        y: [
          {
            title: {
              formatter: function (val) {
                return val + " (mins)";
              },
            },
          },
          {
            title: {
              formatter: function (val) {
                return val + " per session";
              },
            },
          },
          {
            title: {
              formatter: function (val) {
                return val;
              },
            },
          },
        ],
      },
      grid: {
        borderColor: "#f1f1f1",
      },
      colors: ["#7ab2f3"],
    },
  });

  return (
    <div className="w-full">
      <ReactApexChart
        options={state.options}
        series={state.series}
        type="line"
        height={350}
        width="100%"
      />
    </div>
  );
};

const BasicColumnChart = () => {
  const [state, setState] = React.useState({
    series: [
      {
        data: [44, 55, 57, 56, 61],
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
        widrh: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "90%",
          borderRadius: 5,
          borderRadiusApplication: "end",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: ["0-20%", "21-40%", "41-60%", "61-80%", "81-100%"],
      },
      yaxis: {
        title: {
          text: "Number of Candidates",
        },
      },
      fill: {
        opacity: 1,
        colors: ["#6960EC"],
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return "$ " + val + " thousands";
          },
        },
      },
    },
  });

  return (
    <div className="w-full">
      <ReactApexChart
        options={state.options}
        series={state.series}
        type="bar"
        height={350}
        width="100%"
      />
    </div>
  );
};

const BasicColumnChartForJob = () => {
  const [state, setState] = React.useState({
    series: [
      {
        data: [44, 55, 57, 56],
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
        widrh: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "90%",
          borderRadius: 5,
          borderRadiusApplication: "end",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: [
          "UI/UX Designer",
          "Data Scientist",
          "Front Developer",
          "Backend Developer",
        ],
      },
      yaxis: {
        title: {
          text: "Number of Candidates",
        },
      },
      fill: {
        opacity: 1,
        colors: ["#009C97"],
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return "$ " + val + " thousands";
          },
        },
      },
    },
  });

  return (
    <div className="w-full">
      <ReactApexChart
        options={state.options}
        series={state.series}
        type="bar"
        height={350}
        width="100%"
      />
    </div>
  );
};
const BasicColumnChartForJobAiAnalysisManager = () => {
  const [state, setState] = React.useState({
    series: [
      {
        data: [44, 55, 57, 56],
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
        width: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "30%",
          borderRadius: 6,
          borderRadiusApplication: "end",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: [
          "UI/UX Designer",
          "Data Scientist",
          "Front Developer",
          "Backend Developer",
        ],
      },
      yaxis: {
        title: {
          text: "Number of Candidates",
        },
      },
      fill: {
        opacity: 1,
        colors: ["#38ACEC"],
        width: 350,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return "$ " + val + " thousands";
          },
        },
      },
    },
  });

  return (
    <div className="w-full">
      <ReactApexChart
        options={state.options}
        series={state.series}
        type="bar"
        height={350}
        width="100%"
      />
    </div>
  );
};
const BasicColumnChartAverageTimeToFill = () => {
  const [state, setState] = React.useState({
    series: [
      {
        data: [44, 55, 57, 56],
      },
    ],
    options: {
      legend: {
        show: false,
      },
      chart: {
        type: "bar",
        height: 350,
        widrh: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "20%",
          borderRadius: 5,
          borderRadiusApplication: "end",
          distributed: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: [
          "UI/UX Designer",
          "Data Scientist",
          "Front Developer",
          "Backend Developer",
        ],
        title: {
          text: "Job Title",
        },
      },
      yaxis: {
        title: {
          text: "Time",
        },
      },

      colors: ["#7F56D9", "#6440B4", "#52378E", "#4E3584"],
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return "$ " + val + " thousands";
          },
        },
      },
    },
  });

  return (
    <div className="w-full">
      <ReactApexChart
        options={state.options}
        series={state.series}
        type="bar"
        height={350}
        width="100%"
      />
    </div>
  );
};
const BasicColumnChartRecruiterWorkload = () => {
  const [state, setState] = React.useState({
    series: [
      {
        data: [44, 55, 57, 56],
      },
    ],
    options: {
      legend: {
        show: false,
      },
      chart: {
        type: "bar",
        height: 350,
        widrh: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "20%",
          borderRadius: 5,
          borderRadiusApplication: "end",
          distributed: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: ["James", "Oliver", "Zack", "Larry"],
        title: {
          text: "Recruiter",
        },
      },
      yaxis: {
        title: {
          text: "Number of Positions",
        },
      },
      fill: {
        opacity: 1,
        colors: ["#329D9C", "#56C596", "#7BE495", "#B2E7C4"],
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return "$ " + val + " thousands";
          },
        },
      },
    },
  });

  return (
    <div className="w-full">
      <ReactApexChart
        options={state.options}
        series={state.series}
        type="bar"
        height={350}
        width="100%"
      />
    </div>
  );
};

export {
  CircleChart,
  CircleCharCompany,
  CircleChartManager,
  LineDashedChart,
  LineDashedChartCompanyAverage,
  LineDashedChartManager,
  BasicColumnChart,
  BasicColumnChartForJob,
  LineDashedChartCompanySuccess,
  BasicColumnChartAverageTimeToFill,
  BasicColumnChartForJobAiAnalysisManager,
  BasicColumnChartRecruiterWorkload,
};
